import axios from 'axios';
import Cookies from 'js-cookie';

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
        'content-type': 'application/json'
    },
    withCredentials: false
})

api.interceptors.request.use(async(config) => {
    let token = Cookies.get('user-authorization');
    if(token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    let activityId = Cookies.get('activity-id');
    if(!!activityId && activityId !== "undefined") {
        config.headers["X-Pa-Activity"] = activityId
    }
    let organizationId = Cookies.get('organization-id');
    if(!!organizationId && organizationId !== "undefined") {
        config.headers["X-Pa-Organization"] = organizationId
    }
    return config;
});

export default api;